import { useMemo } from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { useTestTrack } from '@betterment/shared-components';

import { UserLevelSettingsDocument } from '../../../edit-user-level-settings/graphql/query.userLevelSettings.generated';
import { SecuritiesLendingStatus } from '../../../graphql/schema';

export const useShouldShowSecurityLending = (): boolean => {
  const { data: userSettingsData } = useGraphQLQuery(UserLevelSettingsDocument, {
    throwOnError: false,
  });

  const testTrack = useTestTrack();

  return useMemo(() => {
    if (!testTrack) {
      return false;
    }

    const isGateEnabled = testTrack.ab('retail.sec_lending_explore_more_q1_2026_enabled', {
      context: 'ProductOnboardingCrossSellCard',
    });
    if (!isGateEnabled) {
      return false;
    }

    const secLendingStatus = userSettingsData?.userLevelSettings?.securityLending?.status;
    const isEligible =
      secLendingStatus !== undefined &&
      (secLendingStatus === SecuritiesLendingStatus.NeverEnrolled ||
        secLendingStatus === SecuritiesLendingStatus.Unenrolled);

    if (!isEligible) {
      return false;
    }

    return (
      testTrack.vary('retail.sec_lending_explore_more_q1_2026_experiment', {
        context: 'ProductOnboardingCrossSellCard',
        defaultVariant: 'control',
      }) === 'treatment'
    );
  }, [userSettingsData, testTrack]);
};
